import { render, staticRenderFns } from "./anli.vue?vue&type=template&id=80568fd8&scoped=true"
import script from "./anli.vue?vue&type=script&lang=js"
export * from "./anli.vue?vue&type=script&lang=js"
import style0 from "./anli.vue?vue&type=style&index=0&id=80568fd8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80568fd8",
  null
  
)

export default component.exports